// Pure helpers for a lead's clients: a primary (contactId/contactName) plus a
// coClients array [{contactId, contactName}]. No React, no Firestore. Shared by
// the lead modals, cards, drawers, and the Follow Up Boss sync so there's one
// source of truth for "who's on this lead."

const coList = (lead) =>
  Array.isArray(lead && lead.coClients) ? lead.coClients : [];

// All clients, primary first, each flagged. Skips a blank primary.
export function listClients(lead) {
  if (!lead) return [];
  const out = [];
  if (lead.contactId) {
    out.push({
      contactId: lead.contactId,
      contactName: lead.contactName || "",
      primary: true,
    });
  }
  coList(lead).forEach((c) => {
    if (c && c.contactId)
      out.push({
        contactId: c.contactId,
        contactName: c.contactName || "",
        primary: false,
      });
  });
  return out;
}

const hasContact = (lead, contactId) =>
  lead.contactId === contactId ||
  coList(lead).some((c) => c && c.contactId === contactId);

// Add a contact: becomes primary if there's no primary yet, else a co-client.
// Deduped — a contact already on the lead is ignored.
export function addCoClient(lead, contact) {
  const base = lead || {};
  if (!contact || !contact.contactId) return base;
  if (hasContact(base, contact.contactId)) return base;
  if (!base.contactId) {
    return {
      ...base,
      contactId: contact.contactId,
      contactName: contact.contactName || "",
      coClients: coList(base),
    };
  }
  return {
    ...base,
    coClients: [
      ...coList(base),
      { contactId: contact.contactId, contactName: contact.contactName || "" },
    ],
  };
}

// Remove a client by id. Removing the primary promotes the first co-client.
export function removeClient(lead, contactId) {
  const base = lead || {};
  if (base.contactId === contactId) {
    const rest = coList(base);
    const next = rest[0];
    return {
      ...base,
      contactId: next ? next.contactId : "",
      contactName: next ? next.contactName || "" : "",
      coClients: rest.slice(1),
    };
  }
  return {
    ...base,
    coClients: coList(base).filter((c) => c && c.contactId !== contactId),
  };
}

export function clientCount(lead) {
  return listClients(lead).length;
}

// Display label: "John", "John & Jane", or "John +2".
export function clientNames(lead) {
  const all = listClients(lead);
  if (all.length === 0) return "";
  if (all.length === 1) return all[0].contactName || "";
  if (all.length === 2) return `${all[0].contactName} & ${all[1].contactName}`;
  return `${all[0].contactName} +${all.length - 1}`;
}
